import { jsx as _jsx } from "react/jsx-runtime";
import { Flex, forwardRef, useColorMode, } from '@chakra-ui/react';
import { theme } from '../../modules/theme';
import { Context } from './context';
export { TimelineConnector } from './TimelineConnector';
export { TimelineContent } from './TimelineContent';
export { TimelineItem } from './TimelineItem';
export { TimelineMarker } from './TimelineMarker';
export const Timeline = forwardRef(({ orientation, size, ...props }, ref) => {
    const { colorMode } = useColorMode();
    return (_jsx(Context.Provider, { value: { orientation, size }, children: _jsx(Flex, { ref: ref, borderColor: theme.colors[colorMode].border[3], flexDirection: orientation === 'horizontal' ? 'row' : 'column', w: "100%", h: "100%", ...props }) }));
});
